import { create } from 'zustand'

import {
  type FlectoLanguages,
  FlectoLanguages as FlectoLanguagesEnum,
} from '@flecto/translations/src/types/FlectoLanguages'
import { type CoreBooking, type UNSAFE_any } from '@flecto/types'

import { type DocumentPreviewData } from '../types/DocumentPreviewData'

type DocumentType = 'quote' | 'contract' | 'proforma'

export type DocumentState = {
  documentPreview: DocumentPreviewData | undefined
  booking: CoreBooking | null
  bookingPublicLink: string
  customerLanguage: FlectoLanguages | undefined
  language: FlectoLanguages | undefined
  taxes: UNSAFE_any
  serviceKinds: UNSAFE_any[]
  translate: ((key: string, params?: UNSAFE_any) => string) | undefined
  isLoaded: boolean
  documentType: DocumentType | undefined

  setCustomerLanguage: (customerLanguage: FlectoLanguages) => void
  setDocumentPreview: (documentPreview: DocumentPreviewData | undefined) => void
  setBooking: (booking: CoreBooking) => void
  setBookingPublicLink: (bookingPublicLink: string) => void
  setLanguage: (language: FlectoLanguages) => void
  setTranslationFunction: (
    t: (key: string, params?: UNSAFE_any) => string
  ) => void
  setLoaded: (isLoaded: boolean) => void
  setDocumentType: (documentType: DocumentType) => void
  reset: () => void
}

const initialState = {
  documentPreview: undefined,
  booking: null,
  bookingPublicLink: '',
  customerLanguage: undefined,
  language: FlectoLanguagesEnum.DEFAULT,
  taxes: null,
  serviceKinds: [],
  translate: undefined,
  isLoaded: false,
  documentType: undefined,
}

export const useDocumentState = create<DocumentState>((set) => ({
  ...initialState,

  setDocumentPreview: (documentPreview) => {
    set({ documentPreview })
  },
  setBooking: (booking) => set({ booking }),
  setCustomerLanguage: (customerLanguage) => set({ customerLanguage }),
  setBookingPublicLink: (bookingPublicLink) => set({ bookingPublicLink }),
  setLanguage: (language) => set({ language }),
  setTranslationFunction: (t) => set({ translate: t }),
  setLoaded: (isLoaded) => set({ isLoaded }),
  setDocumentType: (documentType) => set({ documentType }),
  reset: () => set(initialState),
}))
